export class Element {
  constructor(container) {
    this._container = container;
    this._$container = $(container);
    this.checkDomNodePresence();
  }

  get container() {
    return this._container;
  }

  get $container() {
    return this._$container;
  }

  checkDomNodePresence() {
    if (this.$container.length) return;

    if ($("body").attr("data-env") === "development") {
      console.warn(
        `DEVELOPMENT: Cannot initialize Element, ${this.container} class selector is empty. May be worth double checking...`
      );
    }
  }
}
